import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { Ship } from '../../interfaces/types';
import { ShipStats } from '../../components/ships/ShipStats';
import { Navigation } from '../../components/common/Navigation';
import { authService } from '../../services/authService';
import { Header } from '../../components/common/Header';
import { ProtectedRoute } from '../../components/auth/ProtectedRoute';
import { useSearchParams } from 'react-router-dom';
import './StatsPage.css';

export const StatsPage: React.FC = () => {
  const { data: ships, loading, error } = useApi<Ship[]>('/flota');
  const userData = authService.getUserData();
  const [, setSearchParams] = useSearchParams();
  
  // Estado y lógica del menú hamburguesa
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Limpiar los filtros al entrar
  useEffect(() => {
    setSearchParams({});
  }, [setSearchParams]);

  if (loading) return <div className="loading">Cargando estadísticas...</div>;
  if (error) return <div className="error">Error al cargar las estadísticas: {error.message}</div>;
  if (!ships) return null;

  return (
    <ProtectedRoute>
      <div className="stats-page">
        <Header 
          onToggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
        />

        <nav className="navigation-section" ref={menuRef}>
          <Navigation 
            onCompareToggle={() => {}} 
            isCompareMode={false}
            compareCount={0}
            showCompareButton={true}
            disableCompare={true}
            isMenuOpen={isMenuOpen}
            onCloseMenu={closeMenu}
          />
        </nav>

        <div className="stats-container">
          <ShipStats ships={ships} showUserStats={userData?.admin} />
        </div>
      </div>
    </ProtectedRoute>
  );
}; 